import React, {CSSProperties} from "react";
import '../../styles/common/range-input.scss';

interface IRangeInputProps {
  min: number;
  max: number;
  value: number;
  onMouseDown?: () => void;
  onTouchStart?: () => void;
  onMouseUp?: () => void;
  onTouchEnd?: () => void;
  onChange: (newValue: number) => void;
  label?: string;
  secondaryLabel?: string;
  step?: number;
}

export default function RangeInput({
  min,
  max,
  value,
  onChange,
  onMouseDown,
  onTouchStart,
  onMouseUp,
  onTouchEnd,
  label,
  secondaryLabel,
  step=1,
}: IRangeInputProps) {
  //Chrome does not support styling to the left of the range thumb, therefore we have to implement it ourselves with a gradient background.
  const style: CSSProperties = {
    //@ts-ignore
    "--range-value-percentage": `${((value - min) / (max - min)) * 100}%`,
  };

  return (
    <div className={`range-input`}>
      {createLabelEl(label)} {createSecondaryLabel(secondaryLabel)}
      <input
        type="range"
        min={min}
        max={max}
        value={value}
        step={step}
        onMouseDown={onMouseDown}
        onTouchStart={onTouchStart}
        onMouseUp={onMouseUp}
        onTouchEnd={onTouchEnd}
        onChange={ (e) => {onChange( parseInt(e.target.value)); } }
        style={style}/>
    </div>
  );
}

function createLabelEl(label?: string){
  if (!label) { return; }
  return <span>{label}</span>;
}

function createSecondaryLabel(secondaryLabel?: string){
  if(!secondaryLabel){ return; }
  return <span>{secondaryLabel}</span>
}
